module.exports = {
    bindings: {
        measures: '<'
    },
    templateUrl: 'good/components/import-measures-col-2.html'
};